import React, { useState, useRef, useEffect } from "react";
import { socialMediaApi } from "../../config/api";
import { apiClient } from "../../utils/apiClient";
import "./SocialMedia.scss";

// ─── Social Platforms Config ──────────────────────────────────────────────────
const PLATFORMS = [
  {
    key: "facebook",
    label: "Facebook",
    color: "#1877F2",
    bg: "#e7f0fd",
    border: "#b3d0f7",
    placeholder: "https://facebook.com/yourpage",
    urlPrefix: "https://facebook.com/",
    icon: (
      <svg viewBox="0 0 24 24" fill="#1877F2" width="22" height="22">
        <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.514c-1.491 0-1.956.93-1.956 1.886v2.267h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
      </svg>
    ),
  },
  {
    key: "instagram",
    label: "Instagram",
    color: "#E1306C",
    bg: "#fce8f1",
    border: "#f7b8d2",
    placeholder: "https://instagram.com/yourhandle",
    urlPrefix: "https://instagram.com/",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" width="22" height="22">
        <defs>
          <linearGradient id="ig-grad" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#f09433"/>
            <stop offset="25%" stopColor="#e6683c"/>
            <stop offset="50%" stopColor="#dc2743"/>
            <stop offset="75%" stopColor="#cc2366"/>
            <stop offset="100%" stopColor="#bc1888"/>
          </linearGradient>
        </defs>
        <rect width="24" height="24" rx="6" fill="url(#ig-grad)"/>
        <circle cx="12" cy="12" r="4.5" stroke="#fff" strokeWidth="1.8" fill="none"/>
        <circle cx="17.5" cy="6.5" r="1.2" fill="#fff"/>
      </svg>
    ),
  },
  {
    key: "youtube",
    label: "YouTube",
    color: "#FF0000",
    bg: "#fff0f0",
    border: "#ffb3b3",
    placeholder: "https://youtube.com/@yourchannel",
    urlPrefix: "https://youtube.com/@",
    icon: (
      <svg viewBox="0 0 24 24" fill="#FF0000" width="22" height="22">
        <path d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/>
      </svg>
    ),
  },
  {
    key: "twitter",
    label: "X (Twitter)",
    color: "#000000",
    bg: "#f3f3f3",
    border: "#d1d5db",
    placeholder: "https://x.com/yourhandle",
    urlPrefix: "https://x.com/",
    icon: (
      <svg viewBox="0 0 24 24" fill="#000000" width="22" height="22">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    color: "#0A66C2",
    bg: "#e8f1fb",
    border: "#a8c8f0",
    placeholder: "https://linkedin.com/school/yourpage",
    urlPrefix: "https://linkedin.com/",
    icon: (
      <svg viewBox="0 0 24 24" fill="#0A66C2" width="22" height="22">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
  },
  {
    key: "whatsapp",
    label: "WhatsApp",
    color: "#25D366",
    bg: "#e8fdf0",
    border: "#9ee8b8",
    placeholder: "https://wa.me/919876543210",
    urlPrefix: "https://wa.me/",
    icon: (
      <svg viewBox="0 0 24 24" fill="#25D366" width="22" height="22">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
      </svg>
    ),
  },
  {
    key: "telegram",
    label: "Telegram",
    color: "#26A5E4",
    bg: "#e5f6fd",
    border: "#9dd8f5",
    placeholder: "https://t.me/yourchannel",
    urlPrefix: "https://t.me/",
    icon: (
      <svg viewBox="0 0 24 24" fill="#26A5E4" width="22" height="22">
        <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
      </svg>
    ),
  },
  {
    key: "koo",
    label: "Koo",
    color: "#F5C518",
    bg: "#fffbea",
    border: "#fae98e",
    placeholder: "https://www.kooapp.com/profile/yourhandle",
    urlPrefix: "https://www.kooapp.com/profile/",
    icon: (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
        <circle cx="12" cy="12" r="12" fill="#F5C518"/>
        <text x="12" y="17" textAnchor="middle" fontSize="11" fontWeight="900" fill="#fff" fontFamily="Arial,sans-serif">Koo</text>
      </svg>
    ),
  },
];

const BLANK_LINK = {
  _id: null,
  Platform: "facebook",
  Profile_URL: "",
  Display_Label: "",
  Followers_Subscribers: "",
  Active: true,
  Show_on_Website: true,
  Primary_Platform: false,
  Order: 0,
};

const getPlatform = (key) => PLATFORMS.find((p) => p.key === key) || PLATFORMS[0];

const SocialMedia = () => {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState("");
  const [form, setForm] = useState(BLANK_LINK);
  const [confirm, setConfirm] = useState({ id: null });
  const [dropdown, setDropdown] = useState({ id: null, top: 0, left: 0 });
  const [toast, setToast] = useState("");
  const [activeTab, setActiveTab] = useState("manage");
  const [dragId, setDragId] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => { fetchLinks(); }, []);

  const fetchLinks = async () => {
    try {
      setLoading(true);
      const response = await apiClient(socialMediaApi);
      const result = await response.json();
      if (response.ok) { setLinks(result.data || []); }
    } catch (error) {
      console.error("Error fetching social links:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const onOut = (e) => { if (dropdownRef.current && !dropdownRef.current.contains(e.target)) closeDD(); };
    const onScroll = () => closeDD();
    document.addEventListener("mousedown", onOut);
    window.addEventListener("scroll", onScroll, true);
    return () => {
      document.removeEventListener("mousedown", onOut);
      window.removeEventListener("scroll", onScroll, true);
    };
  }, []);

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 3000); };
  const openDD = (e, id) => {
    e.stopPropagation();
    const r = e.currentTarget.getBoundingClientRect();
    let left = r.right - 220;
    if (left < 8) left = 8;
    setDropdown({ id, top: r.bottom + 8, left });
  };
  const closeDD = () => setDropdown({ id: null, top: 0, left: 0 });

  const openAdd = () => { setForm({ ...BLANK_LINK, Order: links.length + 1 }); setModal("add"); };
  const openEdit = (item) => { setForm({ ...item }); setModal("edit"); closeDD(); };

  const save = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const plat = getPlatform(form.Platform);
      const finalForm = { ...form, Display_Label: form.Display_Label || plat.label };
      const method = modal === "add" ? "POST" : "PUT";
      const url = modal === "add" ? socialMediaApi : `${socialMediaApi}/${form._id}`;
      const response = await apiClient(url, {
        method,
        body: JSON.stringify(finalForm),
      });
      if (response.ok) { fetchLinks(); setModal(""); showToast(`✅ Social link ${modal === "add" ? "added" : "updated"}.`); }
    } catch (error) {
      console.error("Error saving social link:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await apiClient(`${socialMediaApi}/${confirm.id}`, { method: "DELETE" });
      if (response.ok) { fetchLinks(); setConfirm({ id: null }); showToast("🗑️ Social link removed."); }
    } catch (error) {
      console.error("Error deleting social link:", error);
    } finally {
      setLoading(false);
    }
  };

  const updateItem = async (id, patch) => {
    try {
      const item = links.find(l => l._id === id);
      const response = await apiClient(`${socialMediaApi}/${id}`, {
        method: "PUT",
        body: JSON.stringify({ ...item, ...patch }),
      });
      if (response.ok) { fetchLinks(); }
    } catch (error) {
      console.error("Error updating social link:", error);
    }
  };

  const toggleActive = (id) => { const item = links.find(l => l._id === id); updateItem(id, { Active: !item.Active }); closeDD(); };
  const toggleWebsite = (id) => { const item = links.find(l => l._id === id); updateItem(id, { Show_on_Website: !item.Show_on_Website }); showToast("✅ Visibility updated."); closeDD(); };
  const togglePrimary = (id) => {
    links.forEach(l => { if (l.Primary_Platform) updateItem(l._id, { Primary_Platform: false }); });
    updateItem(id, { Primary_Platform: true });
    closeDD();
  };

  const sorted = [...links].sort((a, b) => (a.Order || 0) - (b.Order || 0));
  const visible = sorted.filter((l) => l.Show_on_Website && l.Active);

  const stats = [
    { icon: "🔗", label: "Total Links", value: links.length, color: "#2563eb" },
    { icon: "✅", label: "Active", value: links.filter((l) => l.Active).length, color: "#059669" },
    { icon: "🌐", label: "Visible on Website", value: visible.length, color: "#7c3aed" },
    { icon: "📊", label: "Platforms", value: [...new Set(links.map((l) => l.Platform))].length, color: "#d97706" },
  ];

  return (
    <div className="sm-page">
      {toast && <div className="sm-toast">{toast}</div>}
      <div className="sm-header">
        <div className="sm-header-left">
          <h1>Social Media Management</h1>
          <p>Manage all social media links and profiles displayed on the student website.</p>
        </div>
        <div className="sm-header-actions"><button className="sm-btn-primary" onClick={openAdd}>+ Add Social Link</button></div>
      </div>

      <div className="sm-stats-row">
        {stats.map((s) => (
          <div className="sm-stat-card" key={s.label} style={{ borderTopColor: s.color }}>
            <span className="sm-stat-icon">{s.icon}</span>
            <div><strong style={{ color: s.color }}>{s.value}</strong><p>{s.label}</p></div>
          </div>
        ))}
      </div>

      <div className="sm-tabs">
        <button className={`sm-tab ${activeTab === "manage" ? "active" : ""}`} onClick={() => setActiveTab("manage")}>Manage Links</button>
        <button className={`sm-tab ${activeTab === "preview" ? "active" : ""}`} onClick={() => setActiveTab("preview")}>Website Preview</button>
      </div>

      {loading && <div className="loading-overlay">Loading...</div>}

      {activeTab === "manage" && (
        <div className="sm-tab-content">
          <div className="sm-links-list">
            {sorted.map((link) => {
              const plat = getPlatform(link.Platform);
              return (
                <div key={link._id} className={`sm-link-row ${!link.Active ? "inactive" : ""} ${!link.Show_on_Website ? "hidden" : ""}`}>
                  <div className="sm-order-badge">{link.Order}</div>
                  <div className="sm-platform-icon-wrap" style={{ background: plat.bg, border: `1.5px solid ${plat.border}` }}>{plat.icon}</div>
                  <div className="sm-link-info">
                    <div className="sm-link-top"><strong>{link.Display_Label || plat.label}</strong>{link.Primary_Platform && <span className="sm-primary-badge">⭐ Primary</span>}</div>
                    <div className="sm-link-meta"><span>{plat.label}</span>{link.Followers_Subscribers && <span>👥 {link.Followers_Subscribers}</span>}<a href={link.Profile_URL} target="_blank" rel="noreferrer" className="sm-url-link">{link.Profile_URL} ↗</a></div>
                  </div>
                  <div className="sm-row-right"><label className="sm-toggle"><input type="checkbox" checked={link.Show_on_Website} onChange={() => toggleWebsite(link._id)} /><span className="sm-toggle-slider"/></label><button className="sm-dots" onClick={(e) => openDD(e, link._id)}>⋮</button></div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {activeTab === "preview" && (
        <div className="sm-tab-content">
          <div className="sm-website-preview">
            <div className="sm-wp-header"><h2>Connect With Us</h2><p>Follow us on social media to stay updated.</p></div>
            <div className="sm-wp-featured">
              {visible.slice(0, 3).map((link) => {
                const plat = getPlatform(link.Platform);
                return (
                  <a key={link._id} href={link.Profile_URL} target="_blank" rel="noreferrer" className="sm-wp-featured-card" style={{ borderColor: plat.border }}>
                    <div className="sm-wp-fc-top" style={{ background: plat.bg }}><div className="sm-wp-fc-icon">{plat.icon}</div></div>
                    <div className="sm-wp-fc-body"><strong>{plat.label}</strong><p>{link.Display_Label}</p><span className="sm-wp-follow-btn" style={{ background: plat.color }}>Follow →</span></div>
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {dropdown.id !== null && (
        <div ref={dropdownRef} className="sm-dropdown" style={{ position: "fixed", top: dropdown.top, left: dropdown.left, zIndex: 99999 }}>
          {(() => {
            const item = links.find((x) => x._id === dropdown.id);
            if (!item) return null;
            return (<>
              <button onClick={() => openEdit(item)}>Edit</button>
              <button onClick={() => toggleWebsite(item._id)}>{item.Show_on_Website ? "Hide from Website" : "Show on Website"}</button>
              <button onClick={() => toggleActive(item._id)}>{item.Active ? "Mark Inactive" : "Mark Active"}</button>
              <button onClick={() => togglePrimary(item._id)}>{item.Primary_Platform ? "Remove Primary" : "Mark as Primary"}</button>
              <button className="sm-dd-del" onClick={() => { setConfirm({ id: item._id }); closeDD(); }}>Delete</button>
            </>);
          })()}
        </div>
      )}

      {(modal === "add" || modal === "edit") && (
        <div className="sm-overlay" onClick={() => setModal("")}>
          <div className="sm-form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="sm-modal-head"><h2>{modal === "add" ? "Add Link" : "Edit Link"}</h2><button className="sm-modal-close" onClick={() => setModal("")}>×</button></div>
            <form className="sm-form" onSubmit={save}>
              <div className="sm-field full"><label>Platform *</label><select value={form.Platform} onChange={(e) => setForm({ ...form, Platform: e.target.value })}>{PLATFORMS.map(p => <option key={p.key} value={p.key}>{p.label}</option>)}</select></div>
              <div className="sm-field full"><label>Profile URL *</label><input type="url" required value={form.Profile_URL} onChange={(e) => setForm({ ...form, Profile_URL: e.target.value })} /></div>
              <div className="sm-field-row">
                <div className="sm-field"><label>Label</label><input type="text" value={form.Display_Label} onChange={(e) => setForm({ ...form, Display_Label: e.target.value })} /></div>
                <div className="sm-field"><label>Followers</label><input type="text" value={form.Followers_Subscribers} onChange={(e) => setForm({ ...form, Followers_Subscribers: e.target.value })} /></div>
              </div>
              <div className="sm-checks-row">
                <label className="sm-check-item"><input type="checkbox" checked={form.Show_on_Website} onChange={(e) => setForm({ ...form, Show_on_Website: e.target.checked })} /> Show on Website</label>
                <label className="sm-check-item"><input type="checkbox" checked={form.Active} onChange={(e) => setForm({ ...form, Active: e.target.checked })} /> Active</label>
                <label className="sm-check-item"><input type="checkbox" checked={form.Primary_Platform} onChange={(e) => setForm({ ...form, Primary_Platform: e.target.checked })} /> Primary</label>
              </div>
              <div className="sm-form-footer"><button type="button" className="sm-btn-light" onClick={() => setModal("")}>Cancel</button><button type="submit" className="sm-btn-primary">Save</button></div>
            </form>
          </div>
        </div>
      )}

      {confirm.id !== null && (
        <div className="sm-overlay" onClick={() => setConfirm({ id: null })}>
          <div className="sm-confirm" onClick={(e) => e.stopPropagation()}>
            <h3>Remove this social link?</h3>
            <div className="sm-confirm-actions"><button className="sm-btn-light" onClick={() => setConfirm({ id: null })}>Cancel</button><button className="sm-btn-danger" onClick={handleDelete}>Remove</button></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialMedia;